import React from "react";
import { Router } from "react-router-dom";

import { history } from "./history";

export const AppRouter = ({ children }) => (
  <Router history={history} children={children} />
);
